import { AutogenModelHighwayLoadLockAlerts, AutogenRowHighwayLoadLockAlerts } from "./autogen/AutogenModelHighwayLoadLockAlerts";

export class ModelHighwayLoadLockAlerts extends AutogenModelHighwayLoadLockAlerts<RowHighwayLoadLockAlerts> {
	constructor() {
		super(RowHighwayLoadLockAlerts);
	}
}

export class RowHighwayLoadLockAlerts extends AutogenRowHighwayLoadLockAlerts {
}